<div class="accordion" [id]="accordionId">
	<ng-content></ng-content>
</div>
